import React, { Component } from "react";
import { connect } from "react-redux";
import { setAssetView } from "../../../actions/ui/passport";
import { withRouter } from "react-router-dom";
import { shortenHash} from "../../../config";
import {removeAsset} from "../../../actions/passport/set";
import M from "materialize-css/dist/js/materialize.min.js";
import {Decimal} from 'decimal.js';

class Asset extends Component {
  constructor() {
    super();
    this.state = {
      textType: "Private Key",
      name: "BTC",
      wallet: { address: "", type: "", privateKey: "" },
    };
  }
  handleClick(address) {
    this.props.setAssetView(this.props.title, address);
    this.props.history.push({search:this.props.title.toUpperCase()});
  }
  removeAsset(asset, address, e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.setAssetView("nrg", this.props.firstAddress);
    this.props.removeAsset(asset, address);
  }
  showQR(address){
    console.log(this.props)
    this.props.setAddress(address)
  }
  renderDelete(address) {
    return (
      <a
        className="trash"
        onClick={this.removeAsset.bind(this, this.props.title, address)}
      >
        <span className="material-icons trashIcon">delete</span>
      </a>
    );
  }
  renderQR(address) {
    return (
      <a
        className="trash"
        onClick={this.showQR.bind(this,address)}
      >
        <span className="material-icons trashIcon">qr_code</span>
      </a>
    );
  }
  renderImage(filter) {
    return (
      <img
        style={{filter}}
        src={`./${this.props.title.toLowerCase()}.png`}
        className="assetLogo"
      />
    );
  }
  renderBalance() {
    // background: idx % 2 === 0 ? 'rgb(37, 37, 37, 0)' : 'rgb(37, 37, 37, 0)'
    let items = this.props.addresses.map((address, idx) => {
      let selected =
        this.props.addressView === address.toLowerCase() &&
        this.props.assetView === this.props.title;
      let color = "white";
      let border = selected ? "1px solid white" : "1px solid grey";
      let func = this.handleClick.bind(this, address);
      let isBC = ["emb", "l-emb", "nrg"].includes(this.props.title.toLowerCase());
      let usd = Math.round(100 * this.props.availableAmount[address] * this.props.price[this.props.title.toLowerCase()]) / 100;
      if (isNaN(usd)) usd = 0;
      let filter = selected ? 'invert(1)': 'invert(0)';
      return (
        <div
          style={{}}
          className="col s12"
          key={`${address}${idx}`}
        >
          <h6 className="addr" style={{filter}} onClick={func}
            >
            {this.renderImage(filter)}

            <span style={{ color, opacity: 0.7, fontSize: "0.65rem",marginLeft:'12px'}}>
              {shortenHash(address)}
            </span>
            {this.renderQR(address)}
            {!(idx === 0 && isBC) && this.renderDelete(address)}
            <br />
            <span style={{ color, fontSize: "0.65rem",marginLeft:'12px' }}>
              {this.props.availableAmount[address] ? new Decimal(this.props.availableAmount[address]).toFixed(3) : 0}
              {` ${this.props.title.toUpperCase() === 'NRG' ? 'OL' : this.props.title.toUpperCase()}`}
              {!isBC && (
                <span style={{ color, opacity: 0.75 }}> ({usd} USD)</span>
              )}
            </span>
          </h6>
        </div>
      );
    });
    return <div>{items}</div>;
  }
  render() {
    let borderTop = this.props.index !== 0 ? "1px solid grey" : "";
    let borderBottom = this.props.index !== 9 ? "1px solid grey" : "";
    let src = `./${this.props.title.toLowerCase()}.png`;
    let marginTop = this.props.index !== 0 ? "0px" : "0px";
    return (
      <div>
        <div
          className="col s12 "
          style={{
            padding: 0,
            zIndex: 5,
            marginTop,
          }}
        >
          <div className="col s12" style={{}}>
            {this.props.addresses.length > 0 && this.renderBalance()}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    firstAddress: Object.keys(state.passport.wallet.nrg)[0],
    price: state.price,
    availableAmount: state.passport[props.title]
      ? state.passport[props.title]
      : 0,
    assetView: state.ui_passport.asset_view.toLowerCase(),
    addressView: state.ui_passport.address_view
      ? state.ui_passport.address_view.toLowerCase()
      : "",
    addresses: state.passport.wallet[props.asset]
      ? Object.keys(state.passport.wallet[props.asset])
      : [],
  };
}

export default connect(mapStateToProps, {
  setAssetView,
  removeAsset,
})(withRouter((props) => <Asset {...props} />));
